import {NgModule} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {CommonModule, registerLocaleData} from '@angular/common'
import {RouterModule} from '@angular/router'

/**
 * Компонент базовой верстки
 */
import {MainLayoutComponent} from './main-layout.component'

/**
 * Инициализация Ant-Design
 */
import {NzModule} from '../../nz.module'
import {NZ_ICONS} from 'ng-zorro-antd/icon'
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n'
import {APP_ICONS} from '../../../app-icons'
import en from '@angular/common/locales/en'

/**
 * Общие компоненты
 */
import {MenuComponent} from '../../../shared/components/menu/menu.component'
import {ErrorComponent} from '../error/error.component'

/**
 * Общие сервисы
 */
import {MenuService} from '../../../shared/components/menu/menu.service'

/**
 * Shell modules (eager)
 */
import {MlVsModule} from '../ml-vendor.search/ml.vs.module'
import {DashboardModule} from '../../../components/dashboard/dashboard.module'
import {DashboardComponent} from '../../../components/dashboard/dashboard.component'
import {PipesModule} from '../../pipes.module'
import {LoginAsCompanyComponent} from '../loginPage/asCompany/login.as.company.component'
import {UserGuideModule} from '../user.guide/user.guide.module'
import {AeTaxModule} from '../ae.tax/ae.tax.module'
import {ImageEditorModule} from '../image-editor/image.editor.module'
import {SystemUpdatesModule} from '../system-updates/system-updates.module'

registerLocaleData(en)

/**
 * Регистрация дочерних маршрутов к компонентам с динамическим контентом
 */
const CHILD_ROUTES = [
  {path: 'dashboard', component: DashboardComponent},
  {path: 'error', component: ErrorComponent},
  {path: 'error/403', component: ErrorComponent},
  {
    path: '',
    loadChildren: () => import('../../../components/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/accounts/accounts.module').then(m => m.AccountsModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/advanced-fit/advanced.fit.module').then(m => m.AdvancedFitModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/amenity.management/am.module').then(m => m.AmenityManagerModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/vacation-packages/vp.module').then(m => m.VpModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/marketing-contracts/mc.module').then(m => m.McModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/schedules/schedules.module').then(m => m.SchedulesModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/hotel.schedules/hotel.schedules.module').then(m => m.HotelSchedulesModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/allotments/allotments.module').then(m => m.AllotmentsModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/rate-plans/rp.module').then(m => m.RpModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/rate-levels/rl.module').then(m => m.RlModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/availability/avail.module').then(m => m.AvailModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/discounts/discounts.module').then(m => m.DiscountsModule)
  },
  {
    path: '',
    loadChildren: () => import('../../../components/vendor.items/vi.module').then(m => m.VendorItemModule)
  },
]

@NgModule({
  declarations: [
    MainLayoutComponent,
    MenuComponent,
    ErrorComponent,
    LoginAsCompanyComponent
  ],
  imports: [
    CommonModule,
    NzModule,
    FormsModule,
    MlVsModule,
    RouterModule.forChild([
      {path: '', component: MainLayoutComponent, children: CHILD_ROUTES}
    ]),
    DashboardModule,
    PipesModule,
    AeTaxModule,
    UserGuideModule,
    ImageEditorModule,
    SystemUpdatesModule
  ],
  exports: [
    RouterModule,
  ],
  providers: [
    MenuService,
    {provide: NZ_I18N, useValue: en_US},
    {provide: NZ_ICONS, useValue: APP_ICONS}
  ]
})

export class MainLayoutModule {
  constructor() {
  }
}
